import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import ChargeCommentTextBox from 'chargeComponents/ChargeCommentTextBox';
import ChargeRow from 'chargeComponents/ChargeRow';

class ChargeSelect extends React.Component {

    constructor(props) {
        super(props);

        this.onSelectChange = this
            .onSelectChange
            .bind(this);
    }

    onSelectChange(e) {
        const { charge, chargeActions, orderId } = this.props;

        chargeActions.chargeQuantitySet(charge.get('chargeID'), e.target.value, orderId);
    }

    render() {

        const { charge, useRow, disabled, orderId, chargeActions } = this.props;
        if (!charge) {
            return null;
        }

        const maxQuantity = charge.get('maxQuantity');
        const options = [];
        for (let index = 0; index < maxQuantity + 1; index++) {
            options.push(
                <option
                    key={'qty_option_' + charge.get('chargeID') + "_" + index}
                    value={index}>
                    {index}
                </option>

            );
        }

        const title = charge.get('description');
        let subtitle = null;

        if (charge.get('hasUnsavedChanges')) {
            subtitle = ` Original qty: ${charge.get('originalQuantity')}`;
        }

        const label = (<FormattedNumber value={charge.get('cost')} style="currency" currency="USD" />);

        const select = (
            <select
                disabled={disabled}
                className="browser-default"
                style={{
                    fontSize: '18px'
                }}
                onChange={this.onSelectChange}
                value={charge.get('quantity') != null ? charge.get('quantity') : 0}>
                {options}
            </select>
        );

        let option = null;

        let commentInput = null;

        if (charge.get('requiresComment') && charge.get('quantity') > 0) {
            commentInput = (<ChargeCommentTextBox
                hasUnsavedChanges={charge.get('hasUnsavedChanges')}
                charge={charge}
                orderId={orderId}
                disabled={disabled}
                chargeActions={chargeActions} />);
        }

        if (useRow) {
            option = (
                <div>
                    {select}
                </div>
            );

            return (<ChargeRow
                title={title}
                subtitle={subtitle}
                label={label}
                option={option}
                commentInput={commentInput}
                hasUnsavedChanges={charge.get('hasUnsavedChanges')}
                loading={charge.get('loading')}
                error={charge.get('error')}
                message={charge.get('message')} />);
        }

        return (
            <tr>
                <td
                    style={{
                        paddingTop: '0px',
                        paddingBottom: '0px'
                    }}>{label}</td>
                <td
                    style={{
                        paddingTop: '0px',
                        paddingBottom: '0px',
                        paddingRight: '0px'
                    }}>{select}{commentInput}</td>
            </tr>
        );

    }
}

ChargeSelect.propTypes = {
    chargeActions: PropTypes.object,
    charge: PropTypes.object,
    orderId: PropTypes.string,
    useRow: PropTypes.bool,
    disabled: PropTypes.bool

};
export default ChargeSelect;


// WEBPACK FOOTER //
// ./src/components/charges/ChargeSelect.js